import React, { FC } from 'react';
import { Button, SvgIcon, Grid } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShare } from '@fortawesome/free-solid-svg-icons';
import messages from 'modules/booking/messages';

interface IBookingMenu {
  onShare: () => void;
}

const BookingMenu: FC<IBookingMenu> = ({ onShare }) => {
  return (
    <Grid container spacing={1}>
      <Grid item>
        <Button
          onClick={onShare}
          variant="contained"
          startIcon={
            <SvgIcon>
              <FontAwesomeIcon icon={faShare} />
            </SvgIcon>
          }
        >
          <FormattedMessage {...messages.share} />
        </Button>
      </Grid>
    </Grid>
  );
};

export default BookingMenu;
